/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper, getApiVersionHeader } from '@hems/service/src/util/apiHelper';

import type { CommonResponseWrapper, ListResponse } from 'hems';

import type { DeviceCountByStatus, LastWeekInstalledDeviceCountByStatus } from 'hems/device';
import type { StatisticsDataResponse } from 'hems/device/statistics/common';
import type { StatisticsParams } from 'hems/statistics';

export type DeviceChartParams = {
  cntryCd?: string | null;
  allCntryCd?: string | null;
};
export default class StatisticsService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 사이트 상세 차트 조회 */
  getSiteStatistics = async (siteId: number, params: StatisticsParams): Promise<StatisticsDataResponse> => {
    const { data } = await this.get<CommonResponseWrapper<ListResponse<StatisticsDataResponse>>>(
      apiWrapper.managerApi(`/histories/graphs/${siteId}/ac-system`),
      params,
      {
        headers: getApiVersionHeader(),
      }
    );

    return data.body;
  };

  /** 장비 overview 차트 조회 */
  getDeviceCount = async (params?: DeviceChartParams): Promise<DeviceCountByStatus> => {
    const { data } = await this.get<CommonResponseWrapper<DeviceCountByStatus>>(
      apiWrapper.stateApi('/devices/charts/data/renewal'),
      params
    );

    return data;
  };

  /** 지난 주 설치 장비 대수 조회 */
  getLastWeekInstalledDeviceCount = async (
    params?: DeviceChartParams
  ): Promise<LastWeekInstalledDeviceCountByStatus> => {
    const { data } = await this.get<CommonResponseWrapper<LastWeekInstalledDeviceCountByStatus>>(
      apiWrapper.managerApi('/managements/activities/instl-last-week'),
      params
    );

    return data;
  };
}

export { StatisticsService };
